import React from 'react';
import WebFont from 'webfontloader';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import gtag, { install } from 'ga-gtag';
import { version } from '../package.json';
import IdleManager from "./idle/IdleManager";
import { Routes } from './routes';

import reducers from './reducers';

// styles
import GlobalStyle from './styles/global';
import ReactPixel from 'react-facebook-pixel';

// Facebook Pixel
const options = {
  autoConfig: true,
  debug: false,
};

console.log({ env: process.env.NODE_ENV, version });

ReactPixel.init('400964964142464', options);
ReactPixel.pageView();

let store = '';
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(reducers, composeEnhancers(applyMiddleware(reduxThunk)));
} else {
  store = createStore(reducers, applyMiddleware(reduxThunk));
}

const googleAdsId = 'AW-705761160';
const LOADER_ID = 'ss-gtm-loader';

WebFont.load({
  google: {
    families: [
      'Open Sans:300,400,600,700,800',
      'Open Sans Condensed:300,300i,600,700,800',
      'sans-serif',
    ],
  },
});

window.dataLayer = window.dataLayer || [];

if (process.env.NODE_ENV === 'production') {
  console.log('GTM Initialized');

  if (!document.getElementById(LOADER_ID)) {
    const gtmScript = document.createElement('script');
    gtmScript.id = LOADER_ID;

    // inserido exatamente como enviado 
    gtmScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://load.ss.fabricadolivro.com.br/5fozyrrdh.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','7=AQBPNS03QjI8NzQ%2FOyxJEFVWXENfHgFbDgUQABAZDgIHCBsECxVBBQcJXBAL');`;

    document.head.appendChild(gtmScript);
  }

  // Google Ads
  install(googleAdsId);
  gtag('js', new Date());
  gtag('config', googleAdsId);
}

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <IdleManager />
    <Routes />
  </Provider>,
  document.getElementById('root')
);
